import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccountV2NavigationComponentDef } from '@df/account/v2/navigation/account-v2-navigation.component.def';
import { MultisiteService } from '@df/core/service/multisite';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { PageComponentCountdownBannerComponent } from '../../catalog/ui/page/component/countdown-banner/countdown-banner.component';
import { IfNotAppCustomerDirective } from '../../common/directives/if-not-app-customer.directive';
import { IconLabelComponent } from '../../common/icon-label/icon-label.component';
import { LocalCustomerModel } from '../../customer/customer.model.decorator';
import { TradeStoreService } from '../../multisite/trade/trade-store.service';
import { ActionComponent } from '../../ui/api/action.component';
import { InlineButtonComponent } from '../../ui/buttons/inline-button/inline-button.component';
import { ResultComponent } from '../../ui/resut/result.component';

@Component({
    selector: 'account-navigation',
    templateUrl: './account-navigation.html',
    standalone: true,
    imports: [
        RouterLink,
        IconLabelComponent,
        TranslationModule,
        InlineButtonComponent,
        ResultComponent,
        PageComponentCountdownBannerComponent,
        GridModule,
        NgClass,
        ActionComponent,
        IfNotAppCustomerDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountNavigationComponent extends AccountV2NavigationComponentDef {
    private tradeStoreService = inject(TradeStoreService);
    private multisiteService = inject(MultisiteService);
    private pwaIntegrationService = inject(PwaIntegrationService);
    private customerModel = inject(LocalCustomerModel);

    protected override updateNavigation(): void {
        if (this.pwaIntegrationService.isStandalone && !!this.customerModel.loyaltyId) {
            this.navigation = this.moduleConfig.navigation.filter(i => i.standaloneOnly);
            return;
        }

        if (this.moduleConfig.navigation.length !== 0) {
            const isTrade = this.tradeStoreService.hasTradeMenu();
            const storeId = this.multisiteService.current.siteId;
            this.navigation = this.moduleConfig.navigation.filter(
                i =>
                    !i.isHidden &&
                    !i.standaloneOnly &&
                    (i.trade === undefined || isTrade === i.trade) &&
                    (!i.stores || i.stores.includes(storeId))
            );
        }
    }
}
